import { render, staticRenderFns } from "./AssignmentResource.vue?vue&type=template&id=359f5b70&"
import script from "./AssignmentResource.vue?vue&type=script&lang=js&"
export * from "./AssignmentResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports